<template>
  <div>
    <Header :num111="7" />
    <div
      class="middle1 bg_fff"
      style="margin-top: 14px; padding: 30px; box-sizing: border-box"
    >
      <div class="font-333 flex-wrap">
        <div class="font-333-16-bold align-end">
          <span class="m_r5 xing">*</span>省份:
        </div>
        <el-select
          class="flex-con"
          v-model="pro_id"
          placeholder="请选择省份"
          size="mini"
          style="width: 150px; margin-left: 19px"
          @change="
            (val) => {
              handleChange(val, 1)
            }
          "
        >
          <el-option
            v-for="item in sheng"
            :key="item.district_id"
            :label="item.district"
            :value="item.district_id"
          >
          </el-option>
        </el-select>
        <div class="font-333-16-bold align-end" style="margin-left: 30px">
          <span class="m_r5 xing">*</span>地级市:
        </div>
        <el-select
          class="flex-con"
          v-model="city_id"
          placeholder="请选择城市"
          size="mini"
          style="width: 150px; margin-left: 19px"
          @change="
            (val) => {
              handleChange(val, 2)
            }
          "
        >
          <el-option
            v-for="item in shi"
            :key="item.district_id"
            :label="item.district"
            :value="item.district_id"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="data">
        <div
          style="text-align: center; margin: 60px 0 30px"
          class="font-333-24"
        >
          {{ data.hum_title || '' }}
        </div>
        <div class="font-333-18 fwb" v-html="data.hum_content || ''"></div>
      </div>
      <div v-else>
        <div
          class="font-333-18 fwb"
          style="text-align: center; line-height: 400px; color: #666"
        >
          空空如也~
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import right from '@/components/right.vue'
import { tdkPages, getArea, getInfoByArea } from '../api'
export default {
  components: {
    Header,
    Footer,
    right,
  },
  data() {
    return {
      data: {},
      tdkTitle: '',
      tdkKeywords: '',
      tdkDescription: '',
      sheng: [],
      shi: [],
      pro_id: '',
      city_id: '',
    }
  },
  // metaInfo() {
  //   return {
  //     title: this.tdkTitle,
  //     meta: [
  //       { name: 'keywords', content: this.tdkKeywords },
  //       { name: 'description', content: this.tdkDescription },
  //     ],
  //   }
  // },
  methods: {
    // fnGetTdk(type) {
    //   let params = {
    //     type: type,
    //   }
    //   tdkPages(params).then((data) => {
    //     if (data.status == 200) {
    //       this.tdkTitle = data.msg.title || '爱优服'
    //       this.tdkKeywords = data.msg.keyword || '爱优服'
    //       this.tdkDescription = data.msg.desc || '爱优服'
    //     }
    //   })
    // },
    initSsq() {
      let params = {}
      getArea(params).then((data) => {
        if (data.status == 200) {
          this.sheng = data.data
          // console.log(this.data.user_province + '|' + this.data.user_city)
          if (this.data.user_province > 0) {
            let obj = this.sheng.find(
              (item) => item.district_id == this.data.user_province
            )
            this.shi = obj.items
          }
        }
      })
    },
    getInfo() {
      let params = {
        pro_id: this.pro_id,
        city_id: this.city_id,
      }
      getInfoByArea(params).then((data) => {
        if (data.status == 200) {
          this.data = data.msg
        }
      })
    },
    handleChange(val, type) {
      let obj = {}
      if (type == 1) {
        obj = this.sheng.find((item) => item.district_id == val)
        this.shi = obj.items
        this.city_id = ''
      } else if (type == 2) {
        this.getInfo()
      }
    },
  },
  mounted() {
    this.initSsq()
    // this.fnGetTdk(6)
  },
}
</script>
<style scoped>
.bg_fff {
  background-color: #fff;
}
::v-deep .el-input--mini .el-input__inner {
  border-radius: 0px;
  border: 1px solid #d8d8d8;
  height: 32px;
  font-size: 16px;
  /* color: #999; */
}

.el-select-dropdown__item {
  font-size: 16px;
}
.el-select-dropdown__item.selected {
  color: #333;
}

.width102 {
  /* min-width: 102px; */
  /* text-align: right;
  margin-right: 26px; */
}
.fwb {
  min-height: 500px;
  line-height: 36px;
}

.fwb::-webkit-scrollbar {
  display: none;
}

.xing {
  display: inline-block;
  font-size: 18px;
  line-height: 15px;
  /* font-weight: 500; */
  position: relative;
  top: 0px;
  color: #4b643b;
}
</style>
